export class Statistic {
    public static readonly dispensingTime = new Statistic(1, "DISPENSING_TIME");
    public static readonly pumpPressure = new Statistic(2, "PUMP_PRESSURE");
    public static readonly serviceBoilerPressure = new Statistic(3, "SERVICE_BOILER_PRESSURE");
    public static readonly flow = new Statistic(4, "FLOW");

    private constructor(public readonly code: number, public readonly name: string) {
    }
}
